// extracted by mini-css-extract-plugin
export default {"xs":"VerticalSpace_xs__YF8lA","small":"VerticalSpace_small__5D+Le","normal":"VerticalSpace_normal__PvhjU","large":"VerticalSpace_large__RLJX4"};